import React from "react";
import { cn } from "../../lib/utils";

export function LoadingSpinner({ className, size = "md" }) {
    const sizeClasses = {
        sm: "w-4 h-4 border-2",
        md: "w-6 h-6 border-2",
        lg: "w-8 h-8 border-3",
    };

    return (
        <div
            className={cn(
                "rounded-full border-gray-200 border-t-gray-900 animate-spin",
                sizeClasses[size],
                className
            )}
            data-testid="loading-spinner"
        />
    );
}

export function PageLoader() {
    return (
        <div className="flex items-center justify-center min-h-[400px]">
            <LoadingSpinner size="lg" />
        </div>
    );
}
